<div class="circular-spinner-overlay" [ngClass]="{
  'background': background,
  'white-background': whiteBackground
}"></div>
<div class="ag-theme-balham circular-spinner">
  <span class="ag-icon ag-icon-loading kpi-ag-loading-icon" role="presentation" unselectable="on"></span>
</div>
